export enum AdType {
    BUY = 1,
    SELL = 2,
    RENT = 3,
    SERVICE = 4,
    BUYOUT = 5
}
